// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hero Section Styling */
.hero-image {
  position: relative;
  width: 100%;
  height: 100vh; /* Full screen height */
  background-color: #f0f0f0; /* Fallback color */
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-card-title3 {
  font-size: 20px;
  font-size: 15px;
  
  color:#77DD0D ; /* Dark text */
  margin-bottom: 20px;
  text-align:left;
  padding: 2%
}
.hero-card {
  position: absolute;
  top: 50%;
  left: 20%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 300px;
  background-color: #001D4A;
  opacity: 100%;
  border-radius: 0px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.hero-card-title1 {
  font-size: 20px;
  color: #77DD0D; /* Dark text */
  margin-bottom: 20px;
  text-align: left;
  padding: 2%;
}

.hero-card-title {
  font-size: 45px;
  font-weight: bold;
  color: white;
  margin-bottom: 10px;
  text-align: left;
  margin-top: -10px;
}

.hero-card-description {
  font-size: 18px;
  color: white;
  margin-bottom: 90px;
  margin-left: -20px;
}

.learn-moree-btn {
  background-color: #77DD0D;
  color: white;
  padding: 10px 110px;
  top: -10%;
  border-radius: 5px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  position: relative;
}

.learn-moree-btn:hover {
  background-color: #005c00;
}

.scroll-btn {
  width: 20px !important;
  height: 20px !important;
  background-color: #90f011;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.scroll-btn.active {
  transform: scale(1.2) !important;
  opacity: 1 !important;
}

.scroll-btn:hover {
  transform: scale(1.3) !important;
  background-color: #007e01 !important;
}

.scrolling-buttons {
  position: absolute;
  margin-bottom: -90px;
  display: flex;
  gap: 15px;
  left: 50%;
  transform: translateX(-50%);
  flex-direction: row;
}

/* Dynamic Content Box */
/* Dynamic Content Box */
.dynamic-box {
  position: absolute;
  bottom: 15%;
  left: 70.7%; /* Move box to the left side */
  width: 300px;
  background-color: #001D4A;
  opacity:100%;
  color: white;
 
  padding: 20px;
  border-radius: 10px;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); */
}
.dynamic-box-1 {
  background-color: #cbffef9e; /* Light red background */
  color: #001D4A; /* Dark red text */
}

.dynamic-box-2 {
  background-color: #1140da49; /* Light green background */
  color: white;; /* Dark green text */
}

.dynamic-box-3 {
  background-color: #020b0f5d; /* Light blue background */
  color: white;; /* Dark blue text */
}

.dynamic-box-4 {
  background-color: #dbdb296a; /* Light yellow background */
  color: white;; /* Dark yellow text */
}

.box-content {
  font-size: 25px;
  line-height: 1.5;
}

.HomeServices{
  margin-top: -60px;
}
.HomeServices3{
  margin-bottom: -80px;
  margin-top: -100px;
}


/* .box-content {
  font-size: 16px;
  font-family: 'Arial', sans-serif;
  text-align: center;
  color: #f1f1f1;
  line-height: 1.4;
} */

/* Mobile View */
/* Mobile View of hero card */
@media screen and (max-width: 1200px) {
  .hero-card {
    width: 1100px;
    max-width: 350px;
    height: 200px;
    padding: 80px 20px;
    bottom: 10%; /* Move the card to the right by 10% */
    top:auto;
    left: 5%;
    bottom: 0%;
    transform: translateX(-5%);

  }
  .hero-image {
    
    position: relative;
    padding: 10px 10px;
    width: 100%;
    height: 100vh; /* Full screen height */
    background-color: #f0f0f0; /* Fallback color */
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 40%;
    
  }
  

  .hero-card-title3 {
    font-size: 20px;
    font-size: 15px;
    
    color:#77DD0D ; /* Dark text */
    margin-bottom: 20px;
    text-align:left;
    padding: 2%
  }
  .hero-card-title1
  {
    font-size: 15px;
    
    color:#77DD0D ; /* Dark text */
    margin-bottom: 20px;
    text-align:left;
    padding: 2%;
  }
  .hero-card-title {
    font-size: 30px;
    font-weight: bold;
    color: white; /* Dark text */
    margin-bottom: 20px;
    text-align: left;
  }
  
  .hero-card-description {
    font-size: 18px;
    color: white; /* Neutral text color */
    margin-bottom: 90px;
  }
  .hero-card-description {
    font-size: 18px;
    margin-bottom: 15px;
  }

/*mobile view of scrolling section*/

  .learn-moree-btn {
    font-size: 16px;
    font-weight: 200%;
    padding: 10px 115px;
    height: 25%;
    margin-top: 50px;
    margin-left:-20px ;
    z-index: 100%;
  }

  /* Scrolling Buttons Styling */
  @media screen and (max-width: 1200px) {
    .scrolling-buttons {
      top: 5px; /* Position at the top of the hero image */
      bottom: auto; /* Lower position for smaller screens */
      gap: 8px;
    }
  
    .scroll-btn {
      width: 8px !important; /* Smaller dots for mobile */
      height: 8px !important;
    }
  
    .scroll-btn.active {
      transform: scale(1.1);
    }
  
    .scroll-btn:hover {
      transform: scale(1.2);
    }
    @media (max-width: 768px) 
    {
      .dynamic-box {
        display: none;
        position: relative; /* Change from absolute to relative for better stacking */
        bottom: 0; /* Reset bottom positioning */
        left: 50%; /* Center horizontally */
        transform: translateX(-50%); /* Adjust for centering */
        width: 90%; /* Reduce width for smaller screens */
        font-size: 18px; /* Adjust font size for readability */
        padding: 15px; /* Reduce padding */
        border-radius: 8px; /* Slightly reduce border radius */
      }
    
      .dynamic-box-1,
      .dynamic-box-2,
      .dynamic-box-3,
      .dynamic-box-4 {
        font-size: 16px; /* Adjust font size for all box variations */
      }
    
      .box-content {
        font-size: 20px; /* Adjust content font size */
        line-height: 1.4; /* Adjust line height */
      }
    
      .HomeServices {
        margin-top: -230px; /* Adjust margin for better spacing */
      }
    
      .HomeServices3 {
        margin-bottom: -40px; /* Adjust margin for better spacing */
        margin-top: -100px; /* Adjust top margin */
      }
    
      .hero-card-title1 {
       
        margin-bottom: -50px;
       
      }
      .hero-card {
        position: absolute;
        top: 65%;
       padding-top:30px;
       
      }
    
      

    .learn-moree-btn {
      background-color: #77DD0D;
      color: white;
      padding: 10px 110px;
      top: 0%;
      border-radius: 5px;
      font-weight: bold;
      border: none;
      cursor: pointer;
      position: relative;
      margin-top:10px;
    }
    
    .learn-moree-btn:hover {
      background-color: #005c00;
    }
    
    
    }
  }
  
}`, "",{"version":3,"sources":["webpack://./src/components/Home/Home.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa,EAAE,uBAAuB;EACtC,yBAAyB,EAAE,mBAAmB;EAC9C,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;;EAEf,cAAc,EAAE,cAAc;EAC9B,mBAAmB;EACnB,eAAe;EACf;AACF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,cAAc;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW,EAAE,8BAA8B;EAC3C,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,2BAA2B,EAAE,yBAAyB;EACtD,cAAc,EAAE,kBAAkB;AACpC;;AAEA;EACE,2BAA2B,EAAE,2BAA2B;EACxD,YAAY,GAAG,oBAAoB;AACrC;;AAEA;EACE,2BAA2B,EAAE,0BAA0B;EACvD,YAAY,GAAG,mBAAmB;AACpC;;AAEA;EACE,2BAA2B,EAAE,4BAA4B;EACzD,YAAY,GAAG,qBAAqB;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;;AAGA;;;;;;GAMG;;AAEH,gBAAgB;AAChB,6BAA6B;AAC7B;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,WAAW,EAAE,sCAAsC;IACnD,QAAQ;IACR,QAAQ;IACR,UAAU;IACV,0BAA0B;;EAE5B;EACA;;IAEE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,aAAa,EAAE,uBAAuB;IACtC,yBAAyB,EAAE,mBAAmB;IAC9C,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;;EAEpB;;;EAGA;IACE,eAAe;IACf,eAAe;;IAEf,cAAc,EAAE,cAAc;IAC9B,mBAAmB;IACnB,eAAe;IACf;EACF;EACA;;IAEE,eAAe;;IAEf,cAAc,EAAE,cAAc;IAC9B,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY,EAAE,cAAc;IAC5B,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,YAAY,EAAE,uBAAuB;IACrC,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;;AAEF,mCAAmC;;EAEjC;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;;EAEA,8BAA8B;EAC9B;IACE;MACE,QAAQ,EAAE,0CAA0C;MACpD,YAAY,EAAE,uCAAuC;MACrD,QAAQ;IACV;;IAEA;MACE,qBAAqB,EAAE,4BAA4B;MACnD,sBAAsB;IACxB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,qBAAqB;IACvB;IACA;;MAEE;QACE,aAAa;QACb,kBAAkB,EAAE,yDAAyD;QAC7E,SAAS,EAAE,6BAA6B;QACxC,SAAS,EAAE,wBAAwB;QACnC,2BAA2B,EAAE,yBAAyB;QACtD,UAAU,EAAE,qCAAqC;QACjD,eAAe,EAAE,qCAAqC;QACtD,aAAa,EAAE,mBAAmB;QAClC,kBAAkB,EAAE,kCAAkC;MACxD;;MAEA;;;;QAIE,eAAe,EAAE,4CAA4C;MAC/D;;MAEA;QACE,eAAe,EAAE,6BAA6B;QAC9C,gBAAgB,EAAE,uBAAuB;MAC3C;;MAEA;QACE,kBAAkB,EAAE,qCAAqC;MAC3D;;MAEA;QACE,oBAAoB,EAAE,qCAAqC;QAC3D,kBAAkB,EAAE,sBAAsB;MAC5C;;MAEA;;QAEE,oBAAoB;;MAEtB;MACA;QACE,kBAAkB;QAClB,QAAQ;OACT,gBAAgB;;MAEjB;;;;IAIF;MACE,yBAAyB;MACzB,YAAY;MACZ,mBAAmB;MACnB,OAAO;MACP,kBAAkB;MAClB,iBAAiB;MACjB,YAAY;MACZ,eAAe;MACf,kBAAkB;MAClB,eAAe;IACjB;;IAEA;MACE,yBAAyB;IAC3B;;;IAGA;EACF;;AAEF","sourcesContent":["/* Hero Section Styling */\n.hero-image {\n  position: relative;\n  width: 100%;\n  height: 100vh; /* Full screen height */\n  background-color: #f0f0f0; /* Fallback color */\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.hero-card-title3 {\n  font-size: 20px;\n  font-size: 15px;\n  \n  color:#77DD0D ; /* Dark text */\n  margin-bottom: 20px;\n  text-align:left;\n  padding: 2%\n}\n.hero-card {\n  position: absolute;\n  top: 50%;\n  left: 20%;\n  transform: translate(-50%, -50%);\n  width: 300px;\n  height: 300px;\n  background-color: #001D4A;\n  opacity: 100%;\n  border-radius: 0px;\n  padding: 20px;\n  text-align: center;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.hero-card-title1 {\n  font-size: 20px;\n  color: #77DD0D; /* Dark text */\n  margin-bottom: 20px;\n  text-align: left;\n  padding: 2%;\n}\n\n.hero-card-title {\n  font-size: 45px;\n  font-weight: bold;\n  color: white;\n  margin-bottom: 10px;\n  text-align: left;\n  margin-top: -10px;\n}\n\n.hero-card-description {\n  font-size: 18px;\n  color: white;\n  margin-bottom: 90px;\n  margin-left: -20px;\n}\n\n.learn-moree-btn {\n  background-color: #77DD0D;\n  color: white;\n  padding: 10px 110px;\n  top: -10%;\n  border-radius: 5px;\n  font-weight: bold;\n  border: none;\n  cursor: pointer;\n  position: relative;\n}\n\n.learn-moree-btn:hover {\n  background-color: #005c00;\n}\n\n.scroll-btn {\n  width: 20px !important;\n  height: 20px !important;\n  background-color: #90f011;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  transition: transform 0.2s ease, opacity 0.2s ease;\n}\n\n.scroll-btn.active {\n  transform: scale(1.2) !important;\n  opacity: 1 !important;\n}\n\n.scroll-btn:hover {\n  transform: scale(1.3) !important;\n  background-color: #007e01 !important;\n}\n\n.scrolling-buttons {\n  position: absolute;\n  margin-bottom: -90px;\n  display: flex;\n  gap: 15px;\n  left: 50%;\n  transform: translateX(-50%);\n  flex-direction: row;\n}\n\n/* Dynamic Content Box */\n/* Dynamic Content Box */\n.dynamic-box {\n  position: absolute;\n  bottom: 15%;\n  left: 70.7%; /* Move box to the left side */\n  width: 300px;\n  background-color: #001D4A;\n  opacity:100%;\n  color: white;\n \n  padding: 20px;\n  border-radius: 10px;\n  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); */\n}\n.dynamic-box-1 {\n  background-color: #cbffef9e; /* Light red background */\n  color: #001D4A; /* Dark red text */\n}\n\n.dynamic-box-2 {\n  background-color: #1140da49; /* Light green background */\n  color: white;; /* Dark green text */\n}\n\n.dynamic-box-3 {\n  background-color: #020b0f5d; /* Light blue background */\n  color: white;; /* Dark blue text */\n}\n\n.dynamic-box-4 {\n  background-color: #dbdb296a; /* Light yellow background */\n  color: white;; /* Dark yellow text */\n}\n\n.box-content {\n  font-size: 25px;\n  line-height: 1.5;\n}\n\n.HomeServices{\n  margin-top: -60px;\n}\n.HomeServices3{\n  margin-bottom: -80px;\n  margin-top: -100px;\n}\n\n\n/* .box-content {\n  font-size: 16px;\n  font-family: 'Arial', sans-serif;\n  text-align: center;\n  color: #f1f1f1;\n  line-height: 1.4;\n} */\n\n/* Mobile View */\n/* Mobile View of hero card */\n@media screen and (max-width: 1200px) {\n  .hero-card {\n    width: 1100px;\n    max-width: 350px;\n    height: 200px;\n    padding: 80px 20px;\n    bottom: 10%; /* Move the card to the right by 10% */\n    top:auto;\n    left: 5%;\n    bottom: 0%;\n    transform: translateX(-5%);\n\n  }\n  .hero-image {\n    \n    position: relative;\n    padding: 10px 10px;\n    width: 100%;\n    height: 100vh; /* Full screen height */\n    background-color: #f0f0f0; /* Fallback color */\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    margin-bottom: 40%;\n    \n  }\n  \n\n  .hero-card-title3 {\n    font-size: 20px;\n    font-size: 15px;\n    \n    color:#77DD0D ; /* Dark text */\n    margin-bottom: 20px;\n    text-align:left;\n    padding: 2%\n  }\n  .hero-card-title1\n  {\n    font-size: 15px;\n    \n    color:#77DD0D ; /* Dark text */\n    margin-bottom: 20px;\n    text-align:left;\n    padding: 2%;\n  }\n  .hero-card-title {\n    font-size: 30px;\n    font-weight: bold;\n    color: white; /* Dark text */\n    margin-bottom: 20px;\n    text-align: left;\n  }\n  \n  .hero-card-description {\n    font-size: 18px;\n    color: white; /* Neutral text color */\n    margin-bottom: 90px;\n  }\n  .hero-card-description {\n    font-size: 18px;\n    margin-bottom: 15px;\n  }\n\n/*mobile view of scrolling section*/\n\n  .learn-moree-btn {\n    font-size: 16px;\n    font-weight: 200%;\n    padding: 10px 115px;\n    height: 25%;\n    margin-top: 50px;\n    margin-left:-20px ;\n    z-index: 100%;\n  }\n\n  /* Scrolling Buttons Styling */\n  @media screen and (max-width: 1200px) {\n    .scrolling-buttons {\n      top: 5px; /* Position at the top of the hero image */\n      bottom: auto; /* Lower position for smaller screens */\n      gap: 8px;\n    }\n  \n    .scroll-btn {\n      width: 8px !important; /* Smaller dots for mobile */\n      height: 8px !important;\n    }\n  \n    .scroll-btn.active {\n      transform: scale(1.1);\n    }\n  \n    .scroll-btn:hover {\n      transform: scale(1.2);\n    }\n    @media (max-width: 768px) \n    {\n      .dynamic-box {\n        display: none;\n        position: relative; /* Change from absolute to relative for better stacking */\n        bottom: 0; /* Reset bottom positioning */\n        left: 50%; /* Center horizontally */\n        transform: translateX(-50%); /* Adjust for centering */\n        width: 90%; /* Reduce width for smaller screens */\n        font-size: 18px; /* Adjust font size for readability */\n        padding: 15px; /* Reduce padding */\n        border-radius: 8px; /* Slightly reduce border radius */\n      }\n    \n      .dynamic-box-1,\n      .dynamic-box-2,\n      .dynamic-box-3,\n      .dynamic-box-4 {\n        font-size: 16px; /* Adjust font size for all box variations */\n      }\n    \n      .box-content {\n        font-size: 20px; /* Adjust content font size */\n        line-height: 1.4; /* Adjust line height */\n      }\n    \n      .HomeServices {\n        margin-top: -230px; /* Adjust margin for better spacing */\n      }\n    \n      .HomeServices3 {\n        margin-bottom: -40px; /* Adjust margin for better spacing */\n        margin-top: -100px; /* Adjust top margin */\n      }\n    \n      .hero-card-title1 {\n       \n        margin-bottom: -50px;\n       \n      }\n      .hero-card {\n        position: absolute;\n        top: 65%;\n       padding-top:30px;\n       \n      }\n    \n      \n\n    .learn-moree-btn {\n      background-color: #77DD0D;\n      color: white;\n      padding: 10px 110px;\n      top: 0%;\n      border-radius: 5px;\n      font-weight: bold;\n      border: none;\n      cursor: pointer;\n      position: relative;\n      margin-top:10px;\n    }\n    \n    .learn-moree-btn:hover {\n      background-color: #005c00;\n    }\n    \n    \n    }\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
